<template>
  <f7-page :page-content="true">
    <f7-navbar :back-link="$t('atras')">
      <f7-nav-title v-if="id && !readonly" sliding>Editar ficha de características</f7-nav-title>
      <f7-nav-title v-else-if="id" sliding>Ficha de características</f7-nav-title>
      <f7-nav-title v-else sliding>Nueva ficha de características</f7-nav-title>
      <f7-nav-right>
        <f7-button
          v-if="!readonly"
          fill
          icon-f7="floppy_disk"
          text="Guardar"
          class="display-flex"
          @click="$refs.rform.saveItem()"
        ></f7-button>
        <template slot="right" v-else>
          <f7-button color="blue" @click="readonly=false">{{$t('common.editar')}}</f7-button>
          <f7-button color="red" @click="deleteItem">{{$t('common.eliminar')}}</f7-button>
        </template>
      </f7-nav-right>
    </f7-navbar>

    <r-form
      ref="rform"
      v-slot="{rform}"
      :itemId="id"
      :beforeSave="beforeSave"
      @save="onSave"
      :readonly="readonly"
      :dbAdapter="ItemCaracteristica"
      :defaultData="defaultData"
    >
      <!-- CABECERA -->
      <f7-card class="padding-vertical-half padding-right">
        <f7-card-header><strong>Cabecera</strong></f7-card-header>
        <f7-card-content>
          <f7-row no-gap class="list list-form no-hairlines">
            <f7-col width="50" medium="50" small="100">
              <r-input outline class="col-100" floating-label label="Tipo" :form="rform" type="text" name="tipo"></r-input>
            </f7-col>
            <f7-col width="50" medium="50" small="100">
              <r-input outline class="col-100" floating-label label="Subtipo" :form="rform" type="text" name="subtipo"></r-input>
            </f7-col>
            <f7-col width="100" medium="100" small="100">
              <r-input outline class="col-100" floating-label label="Denominación" :form="rform" type="text" name="denominacion"></r-input>
            </f7-col>
            <f7-col width="50" medium="50" small="100">
              <r-input outline class="col-100" floating-label label="Formato origen" :form="rform" type="text" name="formatoOrigen"></r-input>
            </f7-col>
            <f7-col width="50" medium="50" small="100">
              <r-input outline class="col-100" floating-label label="Naturaleza" :form="rform" type="select" name="naturaleza">
                <option value=""></option>
                <option value="FIJ">FIJ</option>
                <option value="MOV">MOV</option>
                <option value="FIJ_MOV">FIJ_MOV</option>
              </r-input>
            </f7-col>
            <f7-col width="100" medium="100" small="100">
              <r-input outline class="col-100" floating-label label="Reglamento" :form="rform" type="text" name="reglamento"></r-input>
            </f7-col>
            <f7-col width="100" medium="100" small="100">
              <r-input outline class="col-100" floating-label label="Subtipos cubiertos" :form="rform" type="text" name="subtiposCubiertos"></r-input>
            </f7-col>
            <f7-col width="100" medium="100" small="100">
              <r-input outline class="col-100" floating-label label="Documento corroborante" :form="rform" type="text" name="documentoCorroborante"></r-input>
            </f7-col>
          </f7-row>
        </f7-card-content>
      </f7-card>

      <!-- NOTAS DE METODO -->
      <f7-card>
        <f7-card-header>
          <strong>Notas de método</strong>
          <f7-link v-if="!rform.readonly" class="margin-left" icon-f7="plus_circle" @click="addNota(rform)">Añadir</f7-link>
        </f7-card-header>
        <f7-card-content>
          <div v-if="!(rform.formData.notasMetodo && rform.formData.notasMetodo.length)" class="text-color-gray">Sin notas.</div>
          <f7-list v-else>
            <f7-list-item v-for="(n, i) in rform.formData.notasMetodo" :key="'nota-'+i">
              <input slot="title" v-model="rform.formData.notasMetodo[i]" :readonly="rform.readonly" class="full-width-input" />
              <f7-link v-if="!rform.readonly" slot="after" icon-f7="trash" color="red" @click="removeNota(rform, i)"></f7-link>
            </f7-list-item>
          </f7-list>
        </f7-card-content>
      </f7-card>

      <!-- CAMPOS agrupados por seccion -->
      <f7-card>
        <f7-card-header>
          <strong>Campos ({{(rform.formData.campos || []).length}})</strong>
          <f7-link v-if="!rform.readonly" class="margin-left" icon-f7="plus_circle" @click="addCampo(rform)">Añadir campo</f7-link>
        </f7-card-header>
        <f7-card-content>
          <div v-if="!(rform.formData.campos && rform.formData.campos.length)" class="text-color-gray">Sin campos.</div>
          <div v-else>
            <div v-for="(grupo, gIdx) in agrupadosPorSeccion(rform.formData.campos)" :key="'sec-'+gIdx" class="seccion-block">
              <div class="seccion-header"><strong>{{grupo.seccion}}</strong> <span class="text-color-gray">— {{grupo.titulo}}</span></div>
              <table class="campos-table">
                <thead>
                  <tr>
                    <th>Nombre</th>
                    <th>Descripción</th>
                    <th>Tipo dato</th>
                    <th>Obl.</th>
                    <th>Clase</th>
                    <th>Subtipo catálogo</th>
                    <th>Origen formato</th>
                    <th>Observaciones</th>
                    <th>aplicableSi</th>
                    <th v-if="!rform.readonly"></th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="campo in grupo.campos" :key="'c-'+campo.__idx">
                    <td><input v-model="campo.nombre" :readonly="rform.readonly" /></td>
                    <td><input v-model="campo.descripcion" :readonly="rform.readonly" /></td>
                    <td><input v-model="campo.tipoDato" :readonly="rform.readonly" /></td>
                    <td class="text-align-center"><input type="checkbox" v-model="campo.obligatorio" :disabled="rform.readonly" /></td>
                    <td><input v-model="campo.claseDato" :readonly="rform.readonly" /></td>
                    <td><input v-model="campo.subtipoCatalogo" :readonly="rform.readonly" /></td>
                    <td><input v-model="campo.origenFormato" :readonly="rform.readonly" /></td>
                    <td><input v-model="campo.observaciones" :readonly="rform.readonly" /></td>
                    <td><input v-model="campo.aplicableSi" :readonly="rform.readonly" /></td>
                    <td v-if="!rform.readonly">
                      <f7-link icon-f7="trash" color="red" @click="removeCampo(rform, campo.__idx)"></f7-link>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </f7-card-content>
      </f7-card>

      <!-- BLOQUES EXCLUIDOS -->
      <f7-card>
        <f7-card-header>
          <strong>Bloques excluidos ({{(rform.formData.excluidos || []).length}})</strong>
          <f7-link v-if="!rform.readonly" class="margin-left" icon-f7="plus_circle" @click="addExcluido(rform)">Añadir</f7-link>
        </f7-card-header>
        <f7-card-content>
          <div v-if="!(rform.formData.excluidos && rform.formData.excluidos.length)" class="text-color-gray">Sin bloques excluidos.</div>
          <table v-else class="campos-table">
            <thead>
              <tr>
                <th>Bloque</th>
                <th>Contenido</th>
                <th>Destino</th>
                <th v-if="!rform.readonly"></th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(e, i) in rform.formData.excluidos" :key="'e-'+i">
                <td><input v-model="e.bloque" :readonly="rform.readonly" /></td>
                <td><input v-model="e.contenido" :readonly="rform.readonly" /></td>
                <td><input v-model="e.destino" :readonly="rform.readonly" /></td>
                <td v-if="!rform.readonly">
                  <f7-link icon-f7="trash" color="red" @click="removeExcluido(rform, i)"></f7-link>
                </td>
              </tr>
            </tbody>
          </table>
        </f7-card-content>
      </f7-card>
    </r-form>
  </f7-page>
</template>

<style scoped>
.full-width-input {
  width: 100%;
  border: 1px solid #ced4da;
  border-radius: 4px;
  padding: 4px 8px;
}
.seccion-block {
  margin-bottom: 14px;
}
.seccion-header {
  background: #f1f3f5;
  padding: 6px 10px;
  border-radius: 4px;
  margin-bottom: 4px;
}
.campos-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 12px;
}
.campos-table th, .campos-table td {
  border: 1px solid #e9ecef;
  padding: 3px 5px;
  vertical-align: top;
}
.campos-table th {
  background: #f8f9fa;
  font-weight: 600;
  text-align: left;
}
.campos-table input[type="text"], .campos-table input:not([type]) {
  width: 100%;
  border: none;
  background: transparent;
  padding: 2px 4px;
}
.campos-table input:focus {
  background: #fff8e1;
  outline: 1px solid #ffd54f;
}
</style>

<script>
import rForm from "./../../components/rForm.vue";
import rInput from "./../../components/rInput.vue";
import ItemCaracteristica from "./../../js/db/ItemCaracteristica.js";

export default {
  components: {
    rForm,
    rInput
  },
  data() {
    return {
      ItemCaracteristica,
      readonly: !this.editable,
      defaultData: {
        tipo: "",
        subtipo: "",
        denominacion: "",
        formatoOrigen: "",
        reglamento: "",
        naturaleza: "",
        subtiposCubiertos: "",
        documentoCorroborante: "",
        notasMetodo: [],
        campos: [],
        excluidos: []
      }
    };
  },
  props: {
    id: {
      type: String
    },
    editable: {
      type: Boolean,
      default: true
    }
  },
  methods: {
    agrupadosPorSeccion(campos) {
      const grupos = {};
      campos.forEach((c, idx) => {
        c.__idx = idx;
        const key = c.seccion || "(sin sección)";
        if (!grupos[key]) {
          grupos[key] = { seccion: key, titulo: c.seccionTitulo || "", campos: [] };
        }
        grupos[key].campos.push(c);
      });
      return Object.values(grupos).sort((a, b) => a.seccion.localeCompare(b.seccion));
    },
    addNota(rform) {
      if (!rform.formData.notasMetodo) this.$set(rform.formData, "notasMetodo", []);
      rform.formData.notasMetodo.push("");
    },
    removeNota(rform, i) {
      rform.formData.notasMetodo.splice(i, 1);
    },
    addCampo(rform) {
      if (!rform.formData.campos) this.$set(rform.formData, "campos", []);
      rform.formData.campos.push({
        seccion: "",
        seccionTitulo: "",
        nombre: "",
        descripcion: "",
        tipoDato: "Texto",
        obligatorio: false,
        claseDato: "",
        subtipoCatalogo: "",
        origenFormato: "",
        observaciones: "",
        aplicableSi: ""
      });
    },
    removeCampo(rform, idx) {
      rform.formData.campos.splice(idx, 1);
    },
    addExcluido(rform) {
      if (!rform.formData.excluidos) this.$set(rform.formData, "excluidos", []);
      rform.formData.excluidos.push({ bloque: "", contenido: "", destino: "" });
    },
    removeExcluido(rform, i) {
      rform.formData.excluidos.splice(i, 1);
    },
    beforeSave(data, resolve, reject) {
      var errors = {};
      if (!data.tipo || !data.tipo.trim()) errors.tipo = "El tipo es obligatorio";
      if (!data.subtipo || !data.subtipo.trim()) errors.subtipo = "El subtipo es obligatorio";
      if (Object.keys(errors).length) {
        reject({ message: "Revise los campos obligatorios", errors });
        return;
      }
      // Limpia las marcas internas __idx introducidas para el v-for
      if (Array.isArray(data.campos)) {
        data.campos.forEach(c => { delete c.__idx; });
      }
      resolve(data);
    },
    deleteItem() {
      var self = this;
      var app = self.$f7;
      app.dialog.confirm(
        self.$t("rlist.pregunta_eliminar_registro"),
        self.$t("common.eliminar"),
        function() {
          ItemCaracteristica.delete({ itemId: self.id }).then(function(res) {
            if (res) {
              app.toast.create({
                icon: '<i class="f7-icons">checkmark</i>',
                text: self.$t("rlist.registro_eliminado"),
                position: "center",
                destroyOnClose: true,
                closeTimeout: 2000
              }).open();
              self.$f7router.back();
            }
          }).catch(function(error) {
            app.dialog.alert(error.message || error.error || error);
          });
        }
      );
    },
    onSave(res) {
      var self = this;
      var app = self.$f7;
      self.$refs.rform.formData = res;
      self.readonly = true;
      app.toast.create({
        text: self.$t("common.guardado_ok") || "Guardado correctamente",
        position: "center",
        closeTimeout: 2000,
        icon: '<i class="f7-icons">checkmark_alt</i>'
      }).open();
    }
  }
};
</script>
